import { PropsWithChildren } from "react";
import { ChanelUrlTokenValidator } from "./validator/chanel-url-token-validator";

export const ChanelCustomContextProvider = (props: PropsWithChildren) => {
  return <ChanelUrlTokenValidator>{props.children}</ChanelUrlTokenValidator>;
};
